import HomeDashP3 from "./views/hr/HomeDashP3";
import TeamMembersP3 from "./views/hr/TeamMembersP3";
import AdamP3 from "./views/hr/AdamP3";
import ReportsP3 from "./views/hr/ReportsP3";
import NewstarterP3 from "./views/hr/NewstarterP3";
import DashboardsP3 from "./views/hr/DashboardsP3";
import WorkforceInsightP3 from "./views/hr/WorkforceInsightP3";
import HomeDashRecruitP3 from "./views/hr/HomeDashRecruitP3";
import VacanciesP3 from "./views/hr/VacanciesP3";
import CandidatePortalP3 from "./views/hr/CandidatePortalP3";

export default {
  firstName: "Hannah",
  lastName: "Reynolds",
  personaViews: [
    {
      image: "HomeDashP3",
      images: ['HR-Homepage'],
      title: "homeDashboard.persona3.title",
      body: "homeDashboard.persona3.body",
      hotspots: HomeDashP3,
      index: 0,
    },
    {
      image: "TeamMembersP3",
      images: ['HR-Teams'],
      title: "teamMembersP3.title",
      body: "teamMembersP3.body",
      hotspots: TeamMembersP3,
      index: 1,
    },
    {
      image: "AdamP3",
      images: ['HR-Employee'],
      title: "adamP3.title",
      body: "adamP3.body",
      hotspots: AdamP3,
      index: 2,
    },
    {
      image: "ReportsP3",
      images: ['HR-Reports'],
      title: "reportsP3.title",
      body: "reportsP3.body",
      hotspots: ReportsP3,
      index: 3,
    },
    {
      image: "NewstarterP3",
      images: ['HR-Newstarters'],
      title: "newstarterP3.title",
      body: "newstarterP3.body",
      hotspots: NewstarterP3,
      index: 4,
    },
    {
      image: "DashboardsP3",
      images: ['HR-Dashboards'],
      title: "dashboardsP3.title",
      body: "dashboardsP3.body",
      hotspots: DashboardsP3,
      index: 5,
    },
    {
      image: "WorkforceInsightP3",
      images: ['HR-WorkforceInsights'],
      title: "workforceInsightP3.title",
      body: "workforceInsightP3.body",
      hotspots: WorkforceInsightP3,
      index: 6,
    },
    {
      image: "WorkforceInsightP3",
      images: ['HR-Recruit-Homepage'],
      title: "homeDashRecruitP3.title",
      body: "homeDashRecruitP3.body",
      hotspots: HomeDashRecruitP3,
      index: 7,
    },
    {
      image: "VacanciesP3",
      images: ['HR-Vacancies'],
      title: "vacanciesP3.title",
      body: "vacanciesP3.body",
      hotspots: VacanciesP3,
      index: 8,
    },
    {
      image: "candidatePortalP3",
      images: ["HR-Candidate-Portal-1", "HR-Candidate-Portal-2", "HR-Candidate-Portal-3"],
      title: "candidatePortalP3.title",
      body: "candidatePortalP3.body",
      hotspots: CandidatePortalP3,
      index: 9,
    },
  ],
};
